import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_yrt8x5m6m6: FaireBrandEntity = {
  token: "b_yrt8x5m6m6",
  type: "brand",
  name: "The 7 Directions",
  avatarUrl:
    "https://cdn.faire.com/fastly/2da7731e5bf7d6524fbebb83979b671c747a581a25a9f38a56848b087b2fcd0c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ba8e48b0c8e8a334579bb11c6c945591ffebb1e58244833f1e5f3177ea403b97.png",
  logoUrl:
    "https://cdn.faire.com/fastly/2da7731e5bf7d6524fbebb83979b671c747a581a25a9f38a56848b087b2fcd0c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ba8e48b0c8e8a334579bb11c6c945591ffebb1e58244833f1e5f3177ea403b97.png",
  location: "Glendale, CA, USA",
  minimumOrderDollars: 208,
  rating: 5,
  reviewCount: 113,
  isTopShop: true,
  isInsider: true,
  description:
    "World citizen, Ginger Fung resides in Los Angeles, California and has found a passion for working with crystals and meditation. With over 25 years of experience in meditative work, she holds group council and is an experience guide in spiritual journeying. In addition, she is an accomplished flautist and musician, who uses music as a for of vibration healing.\n\nGinger is a firm believer of creating balance of mind, body and spirit, bringing sacredness and self care into your lives through simple practices. ",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:53:06.043Z",
    importedBy: "entity-db-cli",
  },
};
